<template>
  <form @submit.prevent="createEmailNotification">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            name="email"
            type="text"
            v-model.trim="email"
            v-validate="
              'required|email|regex:^([A-Za-z\\d]+[-_\.]?)+@([^\\s@])+\.([^\\s@])+$'
            "
            data-vv-as="email"
            placeholder="Add email address"
            class="form-control"
          />
          <div v-if="veeErrors.first('email')" class="invalid-feedback">
            {{ veeErrors.first("email") }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <!-- Change action button type to 'submit' when functionality is ready, then remove this comment-->
        <ActionButton
          type="submit"
          :theme="{ primary, secondary, event, danger }"
          label="Save"
          style="width: auto; margin-left: auto; margin-top: 0;"
          :disabled="loader"
        />
      </div>
    </div>
  </form>
</template>

<script>
import axios from "@/helpers/axios";

const ActionButton = () => import("@/components/ActionButton");

export default {
  name: "AddEmail",
  components: {
    ActionButton
  },
  data: () => ({
    email: null,
    isActive: false,
    loader: false
  }),
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  methods: {
    async createEmailNotification(event) {
      this.loader = true;
      try {
        const isFormValid = await this.$validator.validateAll();

        if (!isFormValid) {
          let errorMessage = !this.email
            ? "Please fill the required field"
            : "Please fix all errors.";
          throw {
            type: "warning",
            title: "Oops!",
            error: new Error(errorMessage)
          };
        }

        const checkEmail = await axios.get(
          `/emailNotifications?email=${this.email}`
        );

        if (checkEmail.data.data.length > 0) {
          throw {
            type: "warning",
            title: "Warning",
            error: new Error("Email is already used.")
          };
        }

        let formData = new FormData(event.target);
        let form = {};
        for (let pair of formData.entries()) {
          form[pair[0]] = pair[1];
        }

        form.notificationType = "";
        form.status = this.isActive ? 1 : 0;

        let result = {};
        result = await this.$store.dispatch("postEmailNotification", form);

        if (result.data.data) {
          await this.$toastr.success("Your changes are saved", "Success");
          await this.$store.dispatch("fetchEmailNotification");
          this.loader = false;
          this.$emit("close");
        }
      } catch (error) {
        const errType = error.type || "error";
        const errTitle = error.title || "Error";
        const errMsg = error.error.message || error.message;

        this.$toastr[errType](errMsg, errTitle);
      } finally {
        this.loader = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
